<template>
    <div class="join-dialog-tip" :class="[show ? '' : 'hide', displayShow ? '' : 'displayNone']" @click="close">
        <div class="tip-view" :class="show ? '' : 'hide'" @click.stop="joinInOpen">
            <img :src="src" alt="" />
            <i class="el-icon-circle-close" @click.stop="close"></i>
        </div>
    </div>
</template>

<script>
import {WinForm} from '@digital-supply-chain/module'
import {ApiService} from '@/libs'

export default {
    data() {
        return {
            show: false,
            displayShow: false,
            src: `${ApiService.OssHzHost}/jrzz/home_ad/join-3.jpg`,
        }
    },
    mounted() {
        this.open();
    },
    methods: {
        open() {
            // WinForm.storge.remove('join-dialog-close')
            // const joinDialogClose = WinForm.storge.get('join-dialog-close');
            // if (joinDialogClose && joinDialogClose == 1) {
            //     return false;
            // }
            // this.show = true;
            // this.displayShow = true;
        },
        close() {
            this.show = false;
            WinForm.storge.set('join-dialog-close', 1);
            setTimeout(() => this.displayShow = false, 400)
        },
        joinInOpen() {
            this.close();
            setTimeout(() => this.$parent.joinInOpen(), 400)
            
        }
    },
}
</script>

<style lang="less" scoped>
    .join-dialog-tip{
        width: 100vw;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999999;
        background-color: rgba(0, 0, 0, 0.5);
        transition: all 0.4s;
        .tip-view{
            width: 800px;
            height: 136px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -400px;
            margin-top: -136px;
            transition: all 0.4s;
            opacity: 1;
            cursor: pointer;
            img{
                width: 100%;
                height: 100%;
                border-radius: 6px;
            }
        }
        .tip-view.hide{
            transform: scale(1) translateX(calc(-50vw + 436px)) translateY(calc(50vh - 8px));
        }
        .el-icon-circle-close{
            color: #ffffff;
            display: block;
            width: 36px;
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 32px;
            cursor: pointer;
            position: absolute;
            left: 50%;
            margin-left: -13px;
            bottom: -50px;
        }
    }
    .join-dialog-tip.hide{
        opacity: 0;
    }
    .join-dialog-tip.displayNone{
        display: none;
    }
</style>
